import { render, staticRenderFns } from "./AppointmentContainer.vue?vue&type=template&id=1b83a0b1&scoped=true&"
import script from "./AppointmentContainer.vue?vue&type=script&lang=js&"
export * from "./AppointmentContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b83a0b1",
  null
  
)

export default component.exports